import { render, staticRenderFns } from "./DetailedConceptView.vue?vue&type=template&id=430f81d9&scoped=true&"
import script from "./DetailedConceptView.vue?vue&type=script&lang=ts&"
export * from "./DetailedConceptView.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedConceptView.vue?vue&type=style&index=0&id=430f81d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f81d9",
  null
  
)

export default component.exports